<template>
  <div
    id="view-customer"
    class="container-fluid">
    <b-form
      id="customer-form"
      name="customerForm"
      class="pt-1 crud-form"
      @submit.prevent="submitCustomer">
      <div class="row mt-1">
        <div class="col">
          <h3
            class="m-0 text-secondary"
            v-if="customer && !customer.ID">
            Create New Customer
          </h3>

          <h3
            class="m-0 text-secondary"
            v-if="customer && customer.ID">
            Customer Details
          </h3>

          <h3
            class="m-0 text-secondary"
            v-if="!customer">
            &nbsp;
          </h3>

          <hr class="mt-2 mb-0">
        </div>
      </div>

      <div class="row">
        <!-- First Name -->
        <div class="col-3">
          <label for="customer-first-name">
            First Name:
            <small class="text-danger">required</small>
          </label>

          <b-form-input
            id="customer-first-name"
            type="text"
            size="sm"
            name="customerFirstName"
            placeholder="Enter a first name"
            v-model="customer.FirstName"
          />
        </div>
        <!-- / First Name -->

        <!-- Last Name -->
        <div class="col-3 pl-0">
          <label for="customer-last-name">
            Last Name:
            <small class="text-danger">required</small>
          </label>

          <b-form-input
            id="customer-last-name"
            type="text"
            size="sm"
            name="customerLastName"
            placeholder="Enter a last name"
            v-model="customer.LastName"
          />
        </div>
        <!-- / Last Name -->

        <!-- Company -->
        <div class="col-3">
          <label for="customer-company">
            Company:
          </label>

          <b-form-input
            id="customer-company"
            type="text"
            size="sm"
            name="customerCompany"
            placeholder="Enter a company name"
            v-model="customer.Company"
          />
        </div>
        <!-- / Company -->

      </div>

      <div class="row">

        <!-- Email -->
        <div class="col-3">
          <label for="customer-email">
            Email:
          </label>

          <b-form-input
            id="customer-email"
            type="email"
            size="sm"
            name="customerEmail"
            placeholder="Enter an email"
            v-model="customer.Email"
          />
        </div>
        <!-- / Email -->

        <!-- Phone -->
        <div class="col-3 pl-0">
          <label for="customer-phone">
            Phone:
          </label>

          <b-form-input
            id="customer-phone"
            type="text"
            size="sm"
            name="customerPhone"
            placeholder="Enter a phone number"
            v-model="customer.Phone"
          />
        </div>
        <!-- / Phone -->
      </div>

      <div class="row mt-3">
        <!-- Address Line 1 -->
        <div class="col-4">
          <label for="customer-address1">
            Address Line 1:
          </label>

          <b-form-input
            id="customer-address1"
            type="text"
            size="sm"
            name="customerAddress1"
            placeholder="Enter address line 1"
            v-model="customer.Address1"
          />
        </div>
        <!-- / Address Line 1 -->

        <!-- Address Line 2 -->
        <div class="col-4">
          <label for="customer-address2">
            Address Line 2:
          </label>

          <b-form-input
            id="customer-address2"
            type="text"
            size="sm"
            name="customerAddress2"
            placeholder="Enter address line 2"
            v-model="customer.Address2"
          />
        </div>
        <!-- / Address Line 2 -->
      </div>
      <div class="row">
        <!-- City -->
        <div class="col-3">
          <label for="customer-city">
            City:
          </label>

          <b-form-input
            id="customer-city"
            type="text"
            size="sm"
            name="customerCity"
            placeholder="Enter city"
            v-model="customer.City"
          />
        </div>
        <!-- / City -->


        <!-- State -->
        <div class="col-3">
          <label for="customer-state">
            State:
          </label>

          <b-form-select
            id="customer-state"
            name="customerState"
            size="sm"
            :options="states"
            v-model="customer.State"
          />
        </div>
        <!-- State -->

        <!-- Postal Code -->
        <div class="col-3 ">
          <label for="customer-zip">
            Zip:
          </label>

          <b-form-input
            id="customer-zip"
            type="text"
            size="sm"
            name="customerZip"
            placeholder="Enter zip code"
            v-model="customer.PostalCode"
          />
        </div>
        <!-- Postal Code -->

        <!-- Country -->
        <div class="col-3">
          <label for="customer-country">
            Country:
          </label>

          <b-form-input
            id="customer-country"
            type="text"
            size="sm"
            name="customerCountry"
            placeholder="Enter country"
            v-model="customer.Country"
          />
        </div>
        <!-- / Country -->

      </div>

      <div class="row mt-3 crud-actions">


        <div class="col"></div>

        <div class="col-auto d-flex align-items-end">
          <!-- Submit -->
          <b-button
            type="submit"
            size="sm"
            variant="success">
            Save
            <font-awesome-icon icon="save" size="sm"></font-awesome-icon>
          </b-button>
          <!-- / Submit -->

          <!-- Clear / Reset -->
          <b-button
            type="button"
            size="sm"
            class="ml-3"
            variant="primary"
            @click="resetCustomer">
            {{customer.ID ? 'Reset' : 'Clear'}}
            <font-awesome-icon :icon="customer.ID ? 'sync' : 'trash'" size="sm"></font-awesome-icon>
          </b-button>
          <!-- / Clear / Reset -->
        </div>
      </div>
    </b-form>

    <div
      v-if="customer.ID"
      class="row mt-4">
      <div class="col">
        <h3 class="m-0 text-secondary">Licenses & Activations</h3>
        <hr class="mt-2 mb-0">
      </div>
    </div>

    <!-- License Filters -->
    <b-form
      id="licenses-form"
      name="licensesForm"
      class="pt-1 page-form"
      v-if="customer.ID"
      autocomplete="off">
      <input autocomplete="false" name="hidden" type="text" style="display:none;">
      <div class="row">
        <!-- Filters -->
        <div
          id="license-filters"
          class="col page-filters">
          <div class="row">
            <!-- Date Range -->
            <div class="col-3 pr-0 mt-3">
              <b-form-radio-group
                size="sm"
                name="dateBetween"
                buttons
                button-variant="outline-primary"
                v-model="filters.dateBetween">
                <b-form-radio class="mr-1 p-1" value="StartingDate">Issued</b-form-radio>
                <b-form-radio class="p-1" value="ExpirationDate">Expires</b-form-radio>
                <b-form-radio
                  class="p-1 text-body label-radio"
                  disabled>
                  Between:
                </b-form-radio>
              </b-form-radio-group>

              <div class="d-flex mt-1">
                <b-form-input
                  size="sm"
                  class="mr-1 w-50"
                  v-model="filters.fromDate"
                  type="date">
                </b-form-input>

                <b-form-input
                  size="sm"
                  class="w-50"
                  v-model="filters.toDate"
                  type="date">
                </b-form-input>
              </div>
            </div>
            <!-- / Date Range -->

            <!-- License Status -->
            <div class="col-3 pr-0">
              <label>
                Show:
              </label>
              <b-form-radio-group
                class="d-flex align-items-center h-31"
                name="licenseStatus"
                v-model="filters.status">
                <b-form-radio value="active">Active</b-form-radio>

                <b-form-radio
                  value="inactive">
                  Expired
                </b-form-radio>

                <b-form-radio value="both">Both</b-form-radio>
              </b-form-radio-group>
            </div>
            <!-- / License Status -->

            <!-- Over Activations -->
            <div class="col-3 pr-0">
              <label>&nbsp;</label><br>
              <b-form-checkbox
                class="d-flex align-items-center h-31"
                v-model="filters.overActivations">
                Licenses over activation limit
              </b-form-checkbox>
            </div>
            <!-- Over Activations -->
          </div>
        </div>
        <!-- / Filters -->

        <!-- Actions -->
        <div
          id="license-actions"
          class="col-auto d-flex align-items-end page-actions">
          <b-dropdown
            right
            size="sm"
            text="Actions">
            <b-dropdown-item
              class="p-2"
              @click="$router.push({ name: 'new-license', params: customer })">
              <font-awesome-icon
                icon="plus-circle"
                class="mr-1">
              </font-awesome-icon>
              Create License(s)
            </b-dropdown-item>

            <b-dropdown-item
              class="p-2"
              :disabled="selectedLicenses.length !== 1"
              @click="viewLicense(selectedLicenses[0])">
              <font-awesome-icon
                icon="pen"
                class="mr-1">
              </font-awesome-icon>
              Edit License
            </b-dropdown-item>

            <b-dropdown-item
              class="p-2"
              :disabled="
                selectedLicenses.length === 0 ||
                isExpired(selectedLicenses[0].ExpirationDate)
              "
              @click="revokeLicenses">
              <font-awesome-icon
                icon="times-circle"
                class="mr-1">
              </font-awesome-icon>
              Revoke License
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <!-- / Actions -->
      </div>
    </b-form>
    <!-- / License Filters -->

    <div
      id="customer-license-results"
      v-if="customer.ID"
      class="mt-3">
      <b-table
        class="table-fixed"
        v-table-lines
        striped
        hover
        selectable
        select-mode="range"
        @row-dblclicked="viewLicense"
        @row-selected="selectLicenses"
        :sort-compare="sort"
        :items="filteredLicenses"
        :fields="customerFields"
        :show-empty="true"
        empty-text="There are no licenses to show.">
        <template
          slot="Device"
          slot-scope="data">
          <div
            class="sub-cell"
            v-for="u in data.item.Usage"
            :key="u.ID">
            {{u.DeviceThumbprint}}
          </div>
        </template>

        <template
          slot="Activated"
          slot-scope="data">
          <div
            class="sub-cell"
            v-for="u in data.item.Usage"
            :key="u.ID">
            {{u.CreatedDateTime | datetime}}
          </div>
        </template>

        <template
          slot="Approved"
          slot-scope="data">
          <div
            class="sub-cell"
            v-for="u in data.item.Usage"
            :key="u.ID">
            <b-form-checkbox
              v-model="u.Approved"
              @input="approveUsage(u)">
            </b-form-checkbox>
          </div>
        </template>

        <!-- Custom Expiration -->
        <template
          slot="ExpirationDate"
          slot-scope="data">
          <span
            :class="{
              'text-danger':data.item.ExpirationDate.isBefore(),
            }">
            {{data.item.ExpirationDate.format('M/D/YYYY')}}
          </span>
        </template>
        <!-- / Custom Expiration -->
      </b-table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import states from '../services/states';
import DataSvc from '../services/data';
import {
  EventBus,
  GlobalLoaderMixin,
} from '../services/event-bus';
import mixins from '../services/mixins';
import DirtyFormMixin from '../services/dirty-form';

export default {
  name: 'view-customer',
  mixins: [
    EventBus,
    GlobalLoaderMixin,
    mixins,
    DirtyFormMixin,
  ],
  data() {
    return {
      // filters form
      filters: {
        text: '',
        status: 'active',
        dateBetween: 'StartingDate',
        overActivations: false,
      },

      // customer data
      customer: false,
      customerCopy: {},
      states: [{ text: 'Select a state' }].concat(states),
      selectedLicenses: [],
      customerFields: [
        {
          label: 'Access Code',
          key: 'AccessCode',
          sortable: true,
          class: 'license-access-code ellipsis text-uppercase',
        },
        {
          label: 'Device',
          key: 'Device',
          class: 'license-device ellipsis',
          tdClass: 'p-0',
        },
        {
          label: 'Activated',
          key: 'Activated',
          class: 'license-activated ellipsis',
          tdClass: 'text-center p-0',
        },
        {
          label: 'Approved',
          key: 'Approved',
          class: 'license-approved ellipsis',
          tdClass: 'text-center p-0',
        },
        {
          label: 'Device Limit',
          key: 'DeviceLimit',
          sortable: true,
          class: 'license-device-limit ellipsis',
          tdClass: 'text-right',
        },
        {
          label: 'Refresh (Days)',
          key: 'RefreshInterval',
          sortable: true,
          class: 'license-refresh ellipsis',
          tdClass: 'text-right',
        },
        {
          label: 'Issued',
          key: 'StartingDate',
          sortable: true,
          class: 'license-issued ellipsis',
          tdClass: 'text-right',
          formatter: m => m.format('M/D/YYYY'),
        },
        {
          label: 'Expires',
          key: 'ExpirationDate',
          sortable: true,
          class: 'license-valid-thru ellipsis',
          tdClass: 'text-right',
          formatter: m => m.format('M/D/YYYY'),
        },
      ],
    };
  },
  computed: {
    isDirty() {
      const customerJSON = JSON.stringify(this.customer);
      const customerCopyJSON = JSON.stringify(this.customerCopy);
      return !_.isEqual(customerJSON, customerCopyJSON);
    },
    filteredLicenses() {
      const status = l => (this.filters.status === 'active'
          && l.ExpirationDate.isSameOrAfter())
        || (this.filters.status === 'inactive'
          && l.ExpirationDate.isBefore())
        || this.filters.status === 'both';

      const activation = l => (this.filters.overActivations && l.Usage.length > l.DeviceLimit)
        || !this.filters.overActivations;

      const date = prop => l => ((this.filters.fromDate
          && !this.filters.toDate
          && l[prop].isSameOrAfter(this.filters.fromDate))
        || (this.filters.fromDate
          && this.filters.toDate
          && l[prop].isBetween(this.filters.fromDate, this.filters.toDate, null, '[]'))
        || (!this.filters.fromDate
          && this.filters.toDate
          && l[prop].isSameOrBefore(this.filters.toDate))
        || (!this.filters.fromDate && !this.filters.toDate));

      return _.chain(this.customer.Licenses)
        .filter(status)
        .filter(activation)
        .filter(date(this.filters.dateBetween))
        .value();
    },
  },
  methods: {
    submitCustomer() {
      let customerPromise;

      this.showGlobalLoader('Saving customer...');

      if (this.customer.ID) {
        customerPromise = DataSvc.updateCustomer(this.customer);
      } else {
        customerPromise = DataSvc.createCustomer(this.customer);
      }

      return customerPromise
        .then((customer) => {
          this.customer = customer;
          this.customerCopy = _.cloneDeep(customer);
          this.$router.push({ name: 'view-customer', params: customer });
        })
        .finally(() => {
          this.hideGlobalLoader();
        });
    },
    approveUsage(usage) {
      return DataSvc.approveUsage(usage);
    },
    resetCustomer() {
      this.customer = _.cloneDeep(this.customerCopy);
    },
    viewLicense(license) {
      this.$router.push({ name: 'view-license', params: license });
    },
    selectLicenses(licenses) {
      this.selectedLicenses = licenses;
    },
    revokeLicenses() {
      const plural = this.selectedLicenses.length > 1;
      const confirmMsg = `Are you sure you want to revoke
        ${plural ? 'these licenses' : 'this license'}?`;

      const revokeConfirmed = () => {
        this.showGlobalLoader(`Revoking license${plural ? 's' : ''}...`);

        return DataSvc.revokeLicenses(this.selectedLicenses)
          .then(() => this.getCustomer(this.customer.ID))
          .finally(() => {
            this.hideGlobalLoader();
          });
      };

      return this.showConfirm(confirmMsg).then(revokeConfirmed);
    },
    getCustomer(ID) {
      return DataSvc.getCustomer(ID)
        .then((customer) => {
          customer.Licenses.forEach((l) => {
            l.StartingDate = moment(l.StartingDate.replace('Z', ''));
            l.ExpirationDate = moment(l.ExpirationDate.replace('Z', ''));

            if (!l.Usage) {
              l.Usage = [];
            }
          });

          this.customer = customer;
          this.customerCopy = _.cloneDeep(customer);
          this.$nextTick(() => {
            EventBus.$emit('table-data-loaded');
          });
        })
        .catch(() => {
          this.$router.replace({ name: 'list-customers' });
        });
    },
  },
  filters: {
    datetime(iso) {
      return moment(iso).format('M/D/YYYY [at] h:mm:ss a');
    },
  },
  created() {
    const { ID } = this.$route.params;

    if (ID !== 'new') {
      this.showGlobalLoader('Loading customer...');
      this.getCustomer(ID)
        .finally(() => {
          this.hideGlobalLoader();
        });
    } else {
      this.customer = {};
    }
  },
};
</script>

<style lang="scss">
#customer-license-results {
  height: calc(100% - 247px - 42px - 1.5rem - 84px - 2rem);
  margin-bottom: 1rem;

  table.table-fixed {
    .license-access-code {
      width: 360px;
    }

    .license-device {
      width: calc(100% - 360px - 200px - (2 * 150px) - (3 * 100px));
    }

    .license-activated {
      width: 200px;
    }

    .license-approved {
      width: 100px;
    }

    .license-device-limit {
      width: 150px;
    }

    .license-refresh {
      width: 150px;

    }

    .license-issued {
      width: 100px;
    }

    .license-valid-thru {
      width: 100px;
    }

    tr:not(.table-lines) {
      height: auto;
      overflow: hidden;
      td {
        height: auto;
      }
    }
  }
}
</style>
